import axios from 'axios';
import { LOCAL_STORAGE_KEYS } from '@/utils/constants';
import { baseConfig } from './baseClient';

const storage = window.localStorage;

const kioskClient = axios.create(baseConfig);

kioskClient.interceptors.request.use(
  (config) => {
    if (storage.getItem(LOCAL_STORAGE_KEYS.KIOSK_TOKEN)) {
      config.headers.Authorization = `Bearer ${storage.getItem(LOCAL_STORAGE_KEYS.KIOSK_TOKEN)}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(new Error(error));
  },
);

export { kioskClient };
